
const cabinetClientsType = {
  CABINET_CLIENTS_TABLE_STATE_SET: 'CABINET_CLIENTS/TABLE_STATE_SET',
  CABINET_CLIENTS_TABLE_STATE_RESET: 'CABINET_CLIENTS/TABLE_STATE_RESET',
};
export default cabinetClientsType;
